import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IBadgeResource } from "../types";

export type IBadgeDeleteMutationParameters = {
    badge: RelationalValue<IBadgeResource>;
};

export type IBadgeDeleteMutationResult = void;

export const badgeDeleteMutation: IApiMutationFunction<IBadgeDeleteMutationParameters> = ({ badge }) => {
    return {
        method: "DELETE",
        url: `/badges/${mapRelationalValue(badge)}`,
    };
};

export const useBadgeDeleteMutation = createApiMutationHook<IBadgeDeleteMutationParameters, IBadgeDeleteMutationResult>(
    badgeDeleteMutation,
);
